var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78083 10.3753L2.28083 6.00029L5.78083 1.62529C5.8629 1.52273 5.92397 1.40501 5.96055 1.27884C5.99713 1.15268 6.0085 1.02054 5.99402 0.889984C5.97953 0.759425 5.93947 0.632998 5.87613 0.51792C5.81278 0.402843 5.72739 0.301369 5.62483 0.219293C5.52226 0.137217 5.40454 0.0761455 5.27837 0.0395659C5.15221 0.00298635 5.02008 -0.0083851 4.88952 0.00610083C4.75896 0.0205868 4.63253 0.0606464 4.51745 0.123992C4.40238 0.187339 4.3009 0.272731 4.21883 0.375293L0.218825 5.37529C0.0768217 5.55266 -0.000549569 5.77309 -0.000549579 6.00029C-0.000549589 6.2275 0.0768216 6.44793 0.218825 6.62529L4.21883 11.6253C4.38459 11.8324 4.62584 11.9652 4.88952 11.9945C5.15319 12.0237 5.41769 11.9471 5.62483 11.7813C5.72739 11.6992 5.81278 11.5977 5.87613 11.4827C5.93947 11.3676 5.97953 11.2412 5.99402 11.1106C6.02327 10.8469 5.94659 10.5824 5.78083 10.3753V10.3753Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.9298caa688f9e3f0b67e6b31444d48f5.svg";
export { ForwardRef as ReactComponent };